export { default as Img200 } from './processed/200/Vice.jpg';
export { default as Img400 } from './processed/400/Vice.jpg';
export { default as Imgthumb } from './processed/thumb/Vice.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Vice.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Vice.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      236,
      220,
      44
    ],
    "_population": 12704,
    "_hsl": [
      0.15277777777777776,
      0.8347826086956522,
      0.5490196078431373
    ]
  },
  "LightVibrant": {
    "_rgb": [
      230,
      150,
      122
    ],
    "_population": 107,
    "_hsl": [
      0.043209876543209874,
      0.6835443037974683,
      0.6901960784313725
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      18,
      76,
      171
    ],
    "_population": 32,
    "_hsl": [
      0.6034858387799564,
      0.8095238095238095,
      0.3705882352941176
    ]
  },
  "Muted": {
    "_rgb": [
      156,
      125,
      105
    ],
    "_population": 256,
    "_hsl": [
      0.06535947712418298,
      0.2048192771084338,
      0.5117647058823529
    ]
  },
  "LightMuted": {
    "_rgb": [
      120,
      146,
      180
    ],
    "_population": 13,
    "_hsl": [
      0.5944444444444444,
      0.2857142857142858,
      0.5882352941176471
    ]
  },
  "DarkMuted": {
    "_rgb": [
      85,
      62,
      41
    ],
    "_population": 1128,
    "_hsl": [
      0.07954545454545454,
      0.34920634920634913,
      0.24705882352941178
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Vice.js